// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"13d9b654","484":"a3710028","527":"1cc7e3d8","723":"0af0c2db"}[chunkId] + ".css";
};